import {useMemo} from 'react';
import {useJsonFetch} from '@sail/data';
import {AnyNotification} from 'mkt-ssr/lib/notifications/types';
import {DEFAULT_PREFIX, usePrefix} from 'mkt-ssr/lib/globalization';

export type NotificationsAPIResponse = Array<AnyNotification>;

const NOTIFICATIONS_ENDPOINT_BASE = '/notifications?as=json';

export function useNotifications() {
  const prefix = usePrefix();
  const {data} = useJsonFetch<NotificationsAPIResponse>(
    // NB: This is not a pattern we want to replicate, but
    // we cannot pipe this through `createRoute()` because that
    // generates an object, which this method cannot handle, so
    // we manually construct it here. Realistically we should make
    // this endpoint take this as an argument/param, not based on
    // the localization segment, but it's pretty entrenched
    // there at this point.
    prefix === DEFAULT_PREFIX.prefix
      ? NOTIFICATIONS_ENDPOINT_BASE
      : `/${prefix}${NOTIFICATIONS_ENDPOINT_BASE}`,
  );

  return useMemo(() => data || [], [data]);
}
